import { render, staticRenderFns } from "./IotAlertWhitelistForm.vue?vue&type=template&id=00f3e6f4&"
import script from "./IotAlertWhitelistForm.vue?vue&type=script&lang=js&"
export * from "./IotAlertWhitelistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports